import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import SubText from '@components/text/subText'
import zxcvbn from 'zxcvbn'

import {
  Container,
  ForcePasswordContainer,
  ContainerLabel,
  Label,
} from './styles'

const PasswordStrengthChecker = ({ password, style }) => {
  const [score, setScore] = useState(0)
  const [passwordStrengthColors, setPasswordStrengthColors] = useState({})
  const [forcePassword, setForcePassword] = useState({})

  const stateScoreCheck = () => {
    if (password === '') {
      return false
    }
    const pass = zxcvbn(password)
    const result = pass.score
    setScore(result)
    return true
  }

  const checkPasswordStrength = () => {
    const check = stateScoreCheck()

    if (!check) {
      return {
        strength: 'default',
        color: colors.grayBackground,
      }
    }

    if (score === 0) {
      return {
        strength: 'Fraca',
        color: colors.strongRed,
      }
    }

    if (score >= 1 && score < 3) {
      return {
        strength: 'Média',
        color: colors.strongYellow,
      }
    }

    return {
      strength: 'Forte',
      color: colors.strongGreen,
    }
  }

  const getPasswordStrengthColor = () => {
    const { strength } = checkPasswordStrength()

    if (strength === 'default') {
      return {
        first: colors.grayBackground,
        second: colors.grayBackground,
        third: colors.grayBackground,
      }
    }

    if (strength === 'Fraca') {
      return {
        first: colors.strongRed,
        second: colors.grayBackground,
        third: colors.grayBackground,
      }
    }

    if (strength === 'Média') {
      return {
        first: colors.strongYellow,
        second: colors.strongYellow,
        third: colors.grayBackground,
      }
    }

    return {
      first: colors.strongGreen,
      second: colors.strongGreen,
      third: colors.strongGreen,
    }
  }

  useEffect(() => {
    setPasswordStrengthColors(getPasswordStrengthColor())
    setForcePassword(checkPasswordStrength())
  }, [password])

  return (
    <Container style={style}>
      <ForcePasswordContainer>
        <SubText>Força da senha</SubText>
        <SubText style={{ color: forcePassword.color }}>
          {forcePassword.strength === 'default' ? '' : forcePassword.strength}
        </SubText>
      </ForcePasswordContainer>
      <ContainerLabel>
        <Label style={{ backgroundColor: passwordStrengthColors.first }} />
        <Label style={{ backgroundColor: passwordStrengthColors.second }} />
        <Label style={{ backgroundColor: passwordStrengthColors.third }} />
      </ContainerLabel>
    </Container>
  )
}

PasswordStrengthChecker.propTypes = {
  password: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
}

PasswordStrengthChecker.defaultProps = {
  style: null,
}

export default PasswordStrengthChecker
